<template>
  <section id="gs2_content">
    <BaseImage
      src="/static/images/header-menu/icons_logo_white.svg"
      alt="Logo"
      fallbackSrc="/static/images/header-menu/icons_logo_white.svg" />
    <p>
      {{ $_translations.value.page_get_started_title_pt1 }}<br>
      {{ $_translations.value.page_get_started_title_pt2 }}
      <b>{{ $_translations.value.page_get_started_title_pt3 }}</b>!
    </p>
  </section>
</template>

<script setup>
import BaseImage from '@/components/image/BaseImage.vue';
</script>
